<template>
  <b-modal :visible="isOpen"
           @shown="checkFieldsState = true"
           lazy
           centered
           ok-variant="ls order-button-text"
           :ok-disabled="disableOk"
           ok-title-html="Zamów"
           cancel-title="Anuluj"
           title="Formularz zamówienia"
           @ok="orderReward"
           @hidden="clearModal"
           @show="onShow"
           size="lg">
    <b-alert :show="warningMessage.length" fade variant="warning">
      <i class="fa fa-lg fa-exclamation-circle"></i>
      {{ warningMessage }}
    </b-alert>

    <div v-if="stateOrder" class="form-group d-flex flex-row">
      <b-img v-if="stateOrder.picture" :src="stateOrder.picture" height="100" class="m--padding-right-15"></b-img>
      <div>
        <h4>{{ stateOrder.name }}</h4>
        <p v-if="points>0">
          {{pointsName}}, które zostaną wykorzystane:
          <span class="m-badge m-badge--wide m-badge--ls">{{ points }} {{pointsSymbol}}</span>
        </p>
      </div>
    </div>
    <div v-if="stateOrder" class="form-group row">
      <label for="quantity" class="col-5 col-md-3 col-form-label">Liczba&nbsp;sztuk&nbsp;*</label>
      <div class="col-7 col-md-9">
        <input class="form-control" id="quantity"
               :class="[state.order.quantity === false && 'is-invalid', state.order.quantity === true && 'is-valid']"
               type="number"
               min="1"
               :max="stateOrder.order_limit"
               required
               v-model="order.quantity"/>
      </div>
    </div>
    <div v-if="showDeliveryMethodSelect" class="form-group row">
      <label for="name" class="col-5 col-md-3 col-form-label">Sposób odbioru nagrody&nbsp;*</label>
      <div class="col-7 col-md-9">
        <b-form-select id="name"
                       type="text"
                       required
                       :state="state.order.delivery"
                       v-model="order.delivery"
                       :options="deliveryMethods"></b-form-select>
      </div>
    </div>
    <div v-if="showShipmentForm">
      <div class="form-group row">
        <label for="name" class="col-5 col-md-3 col-form-label">Imię&nbsp;*</label>
        <div class="col-7 col-md-9">
          <b-form-input id="name"
                        type="text"
                        required
                        :state="state.order.name"
                        v-model="order.name"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="surname" class="col-5 col-md-3 col-form-label">Nazwisko&nbsp;*</label>
        <div class="col-7 col-md-9">
          <b-form-input id="surname"
                        type="text"
                        required
                        :state="state.order.surname"
                        v-model="order.surname"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="address" class="col-5 col-md-3 col-form-label">Ulica&nbsp;*</label>
        <div class="col-7 col-md-9">
          <b-form-input id="address"
                        type="text"
                        required
                        :state="state.order.address"
                        v-model="order.address"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="city" class="col-5 col-md-3 col-form-label">Miejscowość&nbsp;*</label>
        <div class="col-7 col-md-9">
          <b-form-input id="city"
                        type="text"
                        required
                        :state="state.order.city"
                        v-model="order.city"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="postcode" class="col-5 col-md-3 col-form-label">Kod&nbsp;pocztowy&nbsp;*</label>
        <div class="col-7 col-md-9">
          <b-form-input id="postcode"
                        type="text"
                        required
                        :state="state.order.postcode"
                        v-model="order.postcode"></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <label for="phone" class="col-5 col-md-3 col-form-label">Telefon</label>
        <div class="col-7 col-md-9">
          <b-form-input id="phone"
                        type="text"
                        v-model="order.phone"></b-form-input>
        </div>
      </div>

    </div>
    <div class="form-group row">
      <label for="details" class="col-5 col-md-3 col-form-label">Uwagi</label>
      <div class="col-7 col-md-9">
        <b-form-textarea id="details"
                         v-model="order.details"></b-form-textarea>
      </div>
    </div>
    <div class="mt-4">
      * - Pole wymagane
    </div>
  </b-modal>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import PushIfExists from "@/mixins/pushIfExists";

  export default {
    name: "OrderRewardModal",
    mixins: [PushIfExists],
    data() {
      return {
        checkFieldsState: false,
        warningMessage: "",
        disableOk: false,
        deliveryMethods: [],
        order: {
          delivery: "",
          name: "",
          surname: "",
          address: "",
          city: "",
          postcode: "",
          phone: "",
          details: "",
          quantity: "1",
        },
        state: {
          order: {
            delivery: null,
            name: null,
            surname: null,
            address: null,
            city: null,
            postcode: null,
            quantity: null,
          },
        }
      }
    },
    methods: {
      ...mapActions([
        'clearOrder',
        'clearVariantsOrderModalId',
        'clearVariantsOrder',
        'fetchUser'
      ]),
      setFieldState(field) {
        if (!this.checkFieldsState) {
          return;
        }

        this.state.order[field] = !!(this.order[field] && this.order[field].length);
      },
      onShow() {
        this.setupDeliveries();
        this.cloneUserFromState();
      },
      setupDeliveries() {
        this.deliveryMethods = [
          {
            value: '',
            text: 'Wybierz'
          }
        ];

        if (this.delivery.shipment) {
          this.deliveryMethods.push({
            value: 'shipment',
            text: 'Wysyłka na podany adres',
          });
        }

        if (this.delivery.pickup && this.delivery.pickupShops.length) {
          this.delivery.pickupShops.forEach((shop) => {
            this.deliveryMethods.push({
              value: 'pickup-' + shop.id,
              text: 'Odbiór w ' + shop.name,
            });
          })
        }

        if (!this.showDeliveryMethodSelect) {
          this.order.delivery = 'shipment'; //default shipment
        }
      },
      cloneUserFromState() {
        this.order.name = this.stateUser.name || '';
        this.order.surname = this.stateUser.surname || '';
        this.order.address = this.stateUser.address || '';
        this.order.city = this.stateUser.city || '';
        this.order.postcode = this.stateUser.postcode || '';
        this.order.phone = this.stateUser.phone || '';
      },
      clearForm() {
        this.order.delivery = "";
        this.order.name = "";
        this.order.surname = "";
        this.order.address = "";
        this.order.city = "";
        this.order.postcode = "";
        this.order.phone = "";
        this.order.details = "";
        this.order.quantity = "1";

        this.clearFormState();
      },
      clearFormState() {
        this.state.order.delivery = null;
        this.state.order.name = null;
        this.state.order.surname = null;
        this.state.order.address = null;
        this.state.order.city = null;
        this.state.order.postcode = null;
        this.state.order.quantity = null;
      },
      clearModal() {
        this.clearOrder();
        this.clearVariantsOrderModalId();
        this.clearVariantsOrder();
        this.clearForm();
        this.checkFieldsState = false;
        this.warningMessage = "";
      },
      validateForm: function () {
        for (let field in this.state.order) {
          if (!this.state.order.hasOwnProperty(field)) {
            continue;
          }

          if (field === 'quantity' && Number.parseInt(this.order[field]) === 0) {
            this.state.order[field] = false;
            return;
          }

          this.state.order[field] = !(!this.state.order[field] && !this.order[field].length);
        }
      },
      orderReward(e) {
        e.preventDefault();
        this.warningMessage = "";
        this.validateForm();

        this.isFormValid
          ?
            (this.disableOk = true) && this.$http.post('/rewards', {
            rewardId: this.stateOrder.id,
            quantity: this.order.quantity,
            deliveryType: this.order.delivery,
            delivery: {
              name: this.order.name,
              surname: this.order.surname,
              address: this.order.address,
              city: this.order.city,
              postcode: this.order.postcode,
              phone: this.order.phone,
              details: this.order.details,
            }
          })
            .then((r) => {
              this.disableOk = false;
              if (r.data.success) {
                this.fetchUser();
                this.clearModal();
                this.pushIfExists({name: 'ReceivedRewardsPage'});
                this.$notify(r.data.message, 'info');
              } else {
                this.warningMessage = r.data.message;
              }
            })
          : this.warningMessage = this.order.quantity > 0
          ? "Wypełnij wszystkie pola obowiązkowe."
          : "Liczba sztuk nagrody musi być większa od 0."
      }
    },
    computed: {
      ...mapState({
        isOpen: state => state.rewards.order !== null,
        stateOrder: state => state.rewards.order,
        stateUser: state => state.auth.user,
        delivery: state => state.settings.rewardsOrdersDelivery,
        pointsConfig: state => state.settings.points,
        pointsSymbol() {
          return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
        },
        pointsName() {
          const name = this.pointsConfig.name ? this.pointsConfig.name : 'punkty';

          return name.charAt(0).toUpperCase() + name.slice(1);
        }
      }),
      isFormValid() {
        for (let field in this.state.order) {
          if (!this.state.order.hasOwnProperty(field)) {
            continue;
          }

          if (field === 'quantity' && Number.parseInt(this.order[field]) === 0) {
            return false;
          }

          if (field === 'delivery' && this.order[field].startsWith('pickup')) {
            return true;
          }

          if (!this.state.order[field] && !this.order[field].length) {
            return false;
          }
        }

        return true;
      },
      points() {
        const points = this.stateOrder ? this.stateOrder.points : 1;
        return points * this.order.quantity;
      },
      showShipmentForm() {
        return !this.showDeliveryMethodSelect || this.order.delivery.startsWith('shipment');
      },
      showDeliveryMethodSelect() {
        return !this.delivery.shipment && this.delivery.pickup
            || this.delivery.shipment && this.delivery.pickup;
      }
    },
    watch: {
      'order.name'() {
        this.setFieldState('name');
      },
      'order.surname'() {
        this.setFieldState('surname');
      },
      'order.address'() {
        this.setFieldState('address');
      },
      'order.city'() {
        this.setFieldState('city');
      },
      'order.postcode'() {
        this.setFieldState('postcode');
      },
      'order.details'() {
        this.setFieldState('details');
      },
      'order.quantity'(newValue) {
        this.state.order.quantity = newValue > 0 && newValue <= this.stateOrder.order_limit;

        if (this.stateOrder && newValue > this.stateOrder.order_limit) {
          this.order.quantity = this.stateOrder.order_limit;
        }
      },
      'order.delivery'() {
        this.clearFormState();
      }
    }
  }
</script>

<style scoped>

</style>
